import VectorSource from "ol/source/Vector";
import GeoJSON from "ol/format/GeoJSON";
import VectorTileSource from "ol/source/VectorTile";
import { MVT } from "ol/format";
import XYZ from "ol/source/XYZ";
import TileWMS from "ol/source/TileWMS";
import { createXYZ } from "ol/tilegrid";


export const constants = {
  tileSize: 512,
  servitutsbreite: 70,
};

export const orthoSource = new TileWMS({
  // minZoom: 8,
  url: 'https://kataster.bev.gv.at/ortho/ows',
  projection: 'EPSG:31287',
  crossOrigin: 'anonymous',
  params: {
    'LAYERS': 'inspire:AT_BEV_OI',
    'FORMAT': 'image/jpeg',
  },
  //serverType: 'geoserver',
  tileGrid: createXYZ({tileSize: [512, 512]}),

});

export const amapSource = new XYZ({
  crossOrigin: 'anonymous',
  maxZoom: 18,
  url: "https://maps.bev.gv.at/tiles/karte/{z}/{x}/{y}.png",
});

export const katasterSource = new VectorTileSource({
  format: new MVT(),
  url: "https://kataster.bev.gv.at/tiles/{z}/{x}/{y}.pbf"  
});

export const katasterSymboleSource = new VectorTileSource({
  format: new MVT(),
  url: "https://kataster.bev.gv.at/tiles/{z}/{x}/{y}.pbf"  
});

export const source_planungstrasse = new VectorSource({
  // loader: async () => {
  //   const response = await fetch("/data/planungstrasse_nrk.json");
  //   let data = await response.json();
  //   data.features = data.features.filter(f => f.properties.spannungsebene == "380")
  //   const x =  new GeoJSON().readFeatures(data.features);
  //   console.log(x)
  //   return x
  // },
  url: "data/planungstrasse.geojson",
  // url: "data/planungstrasse_nrk.json",
  format: new GeoJSON(),
});

export const source_variante = new VectorSource({
  url: "data/variante.geojson",
  format: new GeoJSON(),
});


export const source_grobtrasse = new VectorSource({
  url: "data/grobtrasse_nrk.json",
  format: new GeoJSON(),
});



export const source_maststandorte = new VectorSource({
  url: "data/maststandorte_nrk.json",
  format: new GeoJSON(),
});

export const source_wegeplanung = new VectorSource({
  url: "data/wegeplanung_nrk.json",
  format: new GeoJSON(),
});


export const source_anschlusspunkte = new VectorSource({
  url: "data/anschlusspunkte.geojson",
  format: new GeoJSON(),
});

export const source_demontage = new VectorSource({
  url: "data/demontage.geojson",
  format: new GeoJSON(),
});

export const source_uws = new VectorSource({
  url: "data/uws.geojson",
  format: new GeoJSON(),
});

export const source_hinweise = new VectorSource({
  url: "data/hinweise_nrk.json",
  format: new GeoJSON(),
});

export const source_hinweise_overview = new VectorSource({
  url: "data/hinweise_overview_nrk.json",
  format: new GeoJSON(),
});